/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Select from 'react-select';
import axios from 'axios';
import DashboardSection from '../../DashboardContainer/DashboardSection';
import { usePopupManager } from "../../../providers/PopupManager/PopupManager";
import { MESSAGE_TYPE } from "../../../constants";
import DomainTile from '../../DomainTile/DomainTile';
import config from '../../../config/config';
import RecordToReportBarChart from '../../RecordToReportComp/RecordToReportBarChart/RecordToReportBarChart';
import QualityBarChart from '../QualityBarChart/QualityBarChart';
import Qualitykpi from '../TileComponentQuality/Qualitykpi';
import ComplianceTable from '../Tables/ComplianceTable';
import TileNewIcon from './TileNewIcon';
import styles from './MainDashboard.module.css';
import './MainDashboard.css';

const { API_BASE_URL } = config;

// const sampleData = [
//   {
//     Date: '22nd Jan 2025',
//     Observation: ''
//   },
//   {
//     Date: '22nd Jan 2025',
//     Observation: ''
//   },

//   {
//     Date: '22nd Jan 2025',
//     Observation: ''
//   },

//   {
//     Date: '22nd Jan 2025',
//     Observation: ''
//   },

//   {
//     Date: '22nd Jan 2025',
//     Observation: ''
//   },
// ];

// const WeekOptions = [
//   { value: 'undefined', label: 'Select' },
//   { value: 'All', label: '-All-' },
//   ...Array.from({ length: 52 }, (_, i) => ({
//     value: `W${i + 1}`,
//     label: `Week ${i + 1}`
//   }))
// ];

const MainDashBoardQuality = () => {

  const token = useSelector((state) => state.auth.djangoAccessToken);
  const roles = useSelector((state) => state.auth.djangoRoles);
  const userInfo = useSelector((state) => state.auth.djangoUserInfo);

  const location = useLocation();
  const initialFilters = location.state || {
    entityData: null,
    yearData: null,
    monthData: null,
  };

  const history = useHistory();

  const { showPopup } = usePopupManager();
  const [showDashboard, setShowDashboard] = useState(false);
  const [isLoading, setIsLoading] = useState();

  const [hasApplied, setHasApplied] = useState(false);
  const [filters, setFilters] = useState(initialFilters);

  // console.log("filters--------;",filters)

  const [yearOptions, setYearOptions] = useState([]);
  const [monthOptions, setMonthOptions] = useState([]);
  const [year, setYear] = useState([]);
  const [month, setMonth] = useState([]);
  const [entityOptions, setEntityOptions] = useState([]);
  const [entity, setEntity] = useState([]);
  const [observations, setObservations] = useState(null);
  const [SOPdata, setSOPData] = useState([]);
  const [ObservedData, setObservedData] = useState([]);
  const [mrcdata, setMRCData] = useState([]);
  const [Submission, setSubmission] = useState([]);
  const [coverage, setCoverage] = useState([]);
  const [audit, setAudit] = useState([]);

  const [isChecked, setIsChecked] = useState(false);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: '20px',
      flexWrap: 'wrap',
    }),
    valueContainer: (provided) => ({
      ...provided,
      maxHeight: '50px',
      overflowY: 'auto',
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      overflow: 'visible',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      overflowX: 'auto',
      whiteSpace: 'nowrap',
    }),
    option: (provided) => ({
      ...provided,
      padding: '8px 12px',
    }),
  };

  const fetchEntityOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/Quality-entity`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
      .then((response) => {
        setEntityOptions(response.data);
      })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const fetchYearOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/Quality-filters`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
      .then((response) => {
        setYearOptions(response.data[0].year);
        setMonthOptions(response.data[0].month);
      })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const handleEntityChange = (selected) => {
    setEntity(selected);
    setFilters(prev => ({ ...prev, entityData: selected }));
  };

  const handleYearChange = (selected) => {
    setYear(selected);
    setFilters(prev => ({ ...prev, yearData: selected }));
  };

  const handleMonthChange = (selected) => {
    setMonth(selected);
    setFilters(prev => ({ ...prev, monthData: selected }));
  };

  const fetchObservations = async () => {
    setIsLoading(true);
    const entity_data = entity?.map((m) => m?.value) || [];
    const year_data = year?.map((m) => m?.value) || [];
    const month_data = month?.map((m) => m?.value) || [];
    try {
      const response = await axios.post(`${API_BASE_URL}/api/Quality-observations`, {
        selectedentity: entity_data,
        selectedyear: year_data,
        selectedmonth: month_data,
      }, {
        headers: { Authorization: "Basic YWRtaW4xOjEyMw==" }
      });
      setObservations(response.data)
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching observations:", error);
    }
  };

  const fetchSOPData = async () => {
    const entity_data = entity?.map((m) => m?.value) || [];
    const year_data = year?.map((m) => m?.value) || [];
    const month_data = month?.map((m) => m?.value) || [];
    try {
      const response = await axios.post(`${API_BASE_URL}/api/Quality-sop`, {
        selectedentity: entity_data,
        selectedyear: year_data,
        selectedmonth: month_data,
      }, {
        headers: { Authorization: "Basic YWRtaW4xOjEyMw==" }
      });
      setSOPData(response.data.sopdata || []);
    } catch (error) {
      console.error("Error fetching SOP data:", error);
    }
  };

  const fetchObservationsdata = async () => {
    const entity_data = entity?.map((m) => m?.value) || [];
    const year_data = year?.map((m) => m?.value) || [];
    const month_data = month?.map((m) => m?.value) || [];
    try {
      const response = await axios.post(`${API_BASE_URL}/api/Quality-observationgraph`, {
        selectedentity: entity_data,
        selectedyear: year_data,
        selectedmonth: month_data,
      }, {
        headers: { Authorization: "Basic YWRtaW4xOjEyMw==" }
      });

      let data = response.data?.observedata || [];
      if (month?.length) {
        const selectedMonths = month
          .map(m => m.label?.slice(0, 3))
          .map(m => m.charAt(0).toUpperCase() + m.slice(1).toLowerCase());

        if (selectedMonths.length > 0) {
          data = data.filter(item => {
            const itemMonth = item.label?.slice(0, 3);
            return selectedMonths.includes(itemMonth);
          });
        }
      }

      setObservedData(data);
    } catch (error) {
      console.error("Error fetching observation graph:", error);
    }
  };

  const fetchmrcdata = async () => {
    const entity_data = entity?.map((m) => m?.value) || [];
    const year_data = year?.map((m) => m?.value) || [];
    const month_data = month?.map((m) => m?.value) || [];
    try {
      const response = await axios.post(`${API_BASE_URL}/api/Quality-mrc`, {
        selectedentity: entity_data,
        selectedyear: year_data,
        selectedmonth: month_data,
      }, {
        headers: { Authorization: "Basic YWRtaW4xOjEyMw==" }
      });

      let data = response.data?.mrcdata || [];
      if (month?.length) {
        const selectedMonths = month
          .map(m => m.label?.slice(0, 3))
          .map(m => m.charAt(0).toUpperCase() + m.slice(1).toLowerCase());

        data = data.filter(item => {
          const itemMonth = item.label?.slice(0, 3);
          return selectedMonths.includes(itemMonth);
        });
      }

      data = data.sort((a, b) => {
        if (a.label === 'MRC completed') return -1;
        if (b.label === 'MRC completed') return 1;
        return 0;
      });
      setMRCData(data);

    } catch (error) {
      console.error("Error fetching MRC data:", error);
    }
  };

  const fetchtimelydata = async () => {
    const entity_data = entity?.map((m) => m?.value) || [];
    const year_data = year?.map((m) => m?.value) || [];
    const month_data = month?.map((m) => m?.value) || [];
    try {
      const response = await axios.post(`${API_BASE_URL}/api/Quality-timelysub`, {
        selectedentity: entity_data,
        selectedyear: year_data,
        selectedmonth: month_data,
      }, {
        headers: { Authorization: "Basic YWRtaW4xOjEyMw==" }
      });
      const apiData = response.data?.mrcdata || [];
      const towers = apiData.map(item => item.tower || '');
      const datasets = [
        {
          label: 'Total',
          data: apiData.map(item => item.total || 0),
          // backgroundColor: '#3B82F6',
          backgroundColor: '#0072CE',
        }, {
          label: 'Completed',
          data: apiData.map(item => item.completed || 0),
          backgroundColor: '#0fdf69ff',
        },
      ];
      setSubmission({ labels: towers, datasets });
    } catch (error) {
      console.error("Error fetching timely data:", error);
    }
  };

  const fetchCoveragedata = async () => {
    const entity_data = entity?.map((m) => m?.value) || [];
    const year_data = year?.map((m) => m?.value) || [];
    const month_data = month?.map((m) => m?.value) || [];
    try {
      const response = await axios.post(`${API_BASE_URL}/api/Quality-coverage`, {
        selectedentity: entity_data,
        selectedyear: year_data,
        selectedmonth: month_data,
      }, {
        headers: { Authorization: "Basic YWRtaW4xOjEyMw==" }
      });

      let apiData = response.data?.coveragedata || [];
      // apiData = apiData.filter(item => item.tower && item.total !== null && item.completed !== null);

      if (!apiData.length) {
        setCoverage({ labels: [], datasets: [] });
        return;
      }
      const towers = apiData.map(item => item.tower || "Unknown Tower");
      const totalData = apiData.map(item => item.total || 0);
      const completedData = apiData.map(item => item.completed || 0);
      const datasets = [
        {
          label: "Total",
          data: totalData,
          // backgroundColor: "#3B82F6"
          backgroundColor: "#0072CE"
        },
        {
          label: "Completed",
          data: completedData,
          backgroundColor: "#0fdf69ff"
        }
      ];
      setCoverage({ labels: towers, datasets });

    } catch (error) {
      console.error("Error fetching coverage data:", error);
    }
  };

  const fetchauditdetails = async () => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/Quality-audit`,
        {},
        { headers: { Authorization: "Basic YWRtaW4xOjEyMw==" } }
      );
      const formatted = response.data.map((row) => ({
        parameter: row[0],
        year: row[1],
        status: row[2],
        remarks: row[3],
      }));
      setAudit(formatted);
    } catch (error) {
      console.error("Error fetching audit details:", error);
    }
  };

  useEffect(() => {
    fetchEntityOptions();
    fetchYearOptions();
  }, []);

  const handleApply = async () => {
    setShowDashboard(true);
    fetchauditdetails();
    fetchObservations();
    fetchSOPData();
    fetchObservationsdata();
    fetchmrcdata();
    fetchtimelydata();
    fetchCoveragedata();
  };

  const handleReset = () => {
    setShowDashboard(false);
    setHasApplied(false);
    setYear(null);
    setMonth(null);
    setEntity(null);
  };

  useEffect(() => {
    // debugger
    if (entityOptions.length && yearOptions.length && monthOptions.length) {
      let shouldApply = false;

      if (filters.entityData) {
        const ent = entityOptions.find((opt) => opt.value === filters.entityData?.map((m) => m?.value) || []);
        if (ent) {
          setEntity(filters.entityData);
          shouldApply = true;
        }
      }

      if (filters.yearData && filters.yearData.length > 0) {
          const yr = yearOptions.filter(opt =>
              filters.yearData.some(m => (m?.value ?? m) === opt.value)
          );
          if (yr.length > 0) setYear(yr);
        }

      if (filters.monthData && filters.monthData.length > 0) {
          const mon = monthOptions.filter(opt =>
              filters.monthData.some(m => m.value === opt.value)
          );
          if (mon.length > 0) setMonth(mon);
        }

      if (shouldApply) {
        // console.log(shouldApply)
        setHasApplied(true);
      }
    }
  }, [entityOptions, yearOptions, monthOptions]);

  useEffect(() => {
    if (hasApplied) {
      handleApply();
    }
  }, [hasApplied]);

  // const paidOnTimeGradient = 'linear-gradient(135deg, #F43F5E 0%, #DB2777 100%)';
  const paidOnTimeGradient = 'linear-gradient(135deg, #38BDF8 0%, #0284C7 100%)';

  return (
    <>
      <div className={styles.filter_panel_container}>
        <div className={styles.filter_panel_row}>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Entity</label>
            <div className={styles.filter_select_wrapper}>
            <Select
                isMulti={true}
                value={entity}
                onChange={handleEntityChange}
                options={entityOptions}
                isSearchable={true}
                closeMenuOnSelect={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Year</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={year}
                // onChange={setYear}
                options={yearOptions}
                onChange={handleYearChange}
                isSearchable={true}
                isMulti={true}
                closeMenuOnSelect={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Month</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={month}
                // onChange={setMonth}
                onChange={handleMonthChange}
                options={monthOptions}
                isSearchable={true}
                isMulti={true}
                closeMenuOnSelect={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className="filter-panel-col action-buttons">
            <button onClick={handleApply} className="btn apply-btn">
              Apply
            </button>
            <button onClick={handleReset} className="btn reset-btn">
              Reset
            </button>
          </div>
        </div>
      </div>
      {isLoading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div className="text-center">
            <div className="spinner-border text-primary mb-3" role="status"></div>
            <p className="mb-3" style={{ fontSize: "18px", fontWeight: "bold", color: "#0067ac" }}>Loading...</p>
          </div>

        </div>
      )}
      {showDashboard && (
        <>
          <div className="row" style={{ minHeight: "50vh", marginTop: "20px" }}>
            {/* <div className="domain-tile mb-3" style={{ marginTop: '10px' }}>
              <div className="domain">Entity</div>
              <div className={styles.filter_panel_col_inner}>
                <div className={styles.filter_select_wrapper_50_inner}>
                  <Select
                    isMulti
                    placeholder="Select Entity"
                    value={entity}
                    onChange={handleEntityChange}
                    options={entityOptions}
                    isSearchable={false}
                    closeMenuOnSelect={false}
                  />
                </div>
              </div>
            </div> */}
            <div className="col-md-3">
              <DashboardSection disableDetailView={true} className="h-100 w-100">
              {/* <Qualitykpi title="Total Observations" value={observations?.count} /> */}
              <div style={{paddingTop:"10px"}}>
                <TileNewIcon
                  title="Total Observations"
                  number={observations?.count}
                  gradient={paidOnTimeGradient}
                  popupContent="This metric is the Manual CSV Data."
                />

              </div>
              {/* <div style={{ height: "200px" }}>
                <R2RMiniStat
                  title="Total Observations"
                  value={observations?.count}
                  changeText={changeText}
                  isIncrease={isIncrease}
                  showArrow={false}
                  icon={reconciledimg}
                />
              </div> */}
              </DashboardSection>
            </div>
            <div className="col-9">
              <DashboardSection disableDetailView={false} detailPath='/Quality/Quality-observation' title='Quality Observations' className="h-100 w-100" detailState = {filters} infoIcondata={"Manual CSV Data"}>
                <QualityBarChart
                  labels={ObservedData.map(item => item.label || '')}
                  datasets={[
                    {
                      label: 'Observations',
                      data: ObservedData.map(item => item.total || 0),
                      // backgroundColor: '#3B82F6',
                      backgroundColor: '#6F94C9',
                    }
                  ]}
                />
              </DashboardSection>
            </div>
            <div className="col-12 mt-3">
              <div className="row">
                <div className="col-4">
                  <DashboardSection title='Quality Coverage Activity Status' disableDetailView={true} infoIcondata={"Manual CSV Data"}>
                    <QualityBarChart
                      labels={coverage.labels}
                      datasets={coverage.datasets}
                      options={{
                        scales: {
                          x: { grid: { display: false } },
                          y: { grid: { display: false } },
                        },
                        plugins: {
                          datalabels: {
                            color: '#000',
                            font: { weight: 'bold', size: 13 },
                            anchor: 'center',
                            align: 'center',
                          },
                        },
                      }}
                    />
                  </DashboardSection>
                </div>
                <div className="col-4">
                  <DashboardSection
                    disableDetailView={true}
                    title="SOP Audited"
                    className="h-100 w-100"
                    infoIcondata={"Manual CSV Data"}
                  >
                    <QualityBarChart
                      labels={SOPdata.map(item => item.label)}
                      datasets={[
                        {
                          label: 'Total',
                          data: SOPdata.map(item => item.total),
                          // backgroundColor: '#3B82F6',
                          backgroundColor: '#0072CE',
                        },
                        {
                          label: 'Completed',
                          data: SOPdata.map(item => item.completed),
                          // backgroundColor: '#22C55E',
                          backgroundColor: '#0fdf69ff',
                        }
                      ]}
                    />
                  </DashboardSection>
                </div>
                <div className='col-4'>
                  <DashboardSection title='Timely Submission of HCR Reports' disableDetailView={true} infoIcondata={"Manual CSV Data"}>
                    <QualityBarChart labels={Submission.labels || []}
                      datasets={Submission.datasets || []}
                    />
                  </DashboardSection>
                </div>
              </div>
            </div>
            <div className="col-12 mt-3">
              <div className="row">
                <div className='col-6'>
                  <DashboardSection title="MRC Status" disableDetailView={false} detailPath="/Quality/mrc"  detailState = {filters} infoIcondata={"Manual CSV Data"}>
                    <QualityBarChart
                      labels={mrcdata.map(item => item.label || '')}
                      datasets={[
                        {
                          label: 'Total',
                          data: mrcdata.map(item => item.total || 0),
                          // backgroundColor: '#3B82F6',
                          backgroundColor: '#0072CE',
                        },
                        {
                          label: 'Completed',
                          data: mrcdata.map(item => item.completed || 0),
                          backgroundColor: '#0fdf69ff',
                        },
                      ]}
                      options={{
                        scales: {
                          x: {
                            grid: { display: false },
                          },
                          y: {
                            grid: { display: false },
                          },
                        },
                      }}
                    />
                  </DashboardSection>
                </div>
                {/* <div className='col-6'>
                  <DashboardSection title='Timely Submission of HCR Reports' disableDetailView={true}>
                    <RecordToReportBarChart labels={Submission.labels || []}
                      datasets={Submission.datasets || []}
                    />
                  </DashboardSection>
                </div> */}
                <div className='col-6'>
                  {/* <DomainTile title='ISO Audit Request Details'></DomainTile> */}
                  <DashboardSection title='ISO Audit Request Details' disableDetailView={true} infoIcondata={"Manual CSV Data"}>
                    <ComplianceTable data={audit} />
                  </DashboardSection>
                </div>
              </div>
            </div>
          </div>
          {/* <div className='row mt-3'>
            <div className='col-12'>
              <DomainTile title='ISO Audit Request Details'></DomainTile>
              <ComplianceTable data={audit} />
            </div>
          </div> */}
        </>
      )}
    </>
  );
};

export default MainDashBoardQuality;
